import React, { useEffect, useState } from 'react';

export type CccComercialUserOption = {
  id: number;
  name: string;
  username?: string;
  email?: string;
};

type Props = {
  open: boolean;
  empresa?: string;
  users: CccComercialUserOption[];
  submitting?: boolean;
  currentComercialUserId?: number | null;
  onClose: () => void;
  onConfirm: (payload: { comercial_user_id?: number }) => void;
};

const CccReverterModal: React.FC<Props> = ({
  open,
  empresa,
  users,
  submitting = false,
  currentComercialUserId = null,
  onClose,
  onConfirm,
}) => {
  const [alterarComercial, setAlterarComercial] = useState(false);
  const [userId, setUserId] = useState<string>('');

  useEffect(() => {
    if (open) {
      setAlterarComercial(false);
      setUserId(currentComercialUserId != null ? String(currentComercialUserId) : '');
    }
  }, [open, currentComercialUserId]);

  if (!open) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (alterarComercial) {
      const parsed = Number(userId);
      if (!Number.isFinite(parsed)) return;
      onConfirm({ comercial_user_id: parsed });
      return;
    }
    onConfirm({});
  };

  return (
    <div
      className="rec-modal-backdrop"
      onClick={() => !submitting && onClose()}
      role="presentation"
    >
      <div
        className="rec-modal rec-modal--reverter-comercial"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="ccc-reverter-title"
      >
        <div className="rec-modal-head">
          <h2 id="ccc-reverter-title" className="rec-modal-title">
            Reverter para Comercial
          </h2>
        </div>
        <form className="rec-modal-body" onSubmit={handleSubmit}>
          <p className="rec-modal-text">
            A marcação volta à Gestão Comercial. Inicia um período de espera antes de voltar ao pool
            de Recuperação.
          </p>
          {empresa ? <p className="rec-modal-empresa">{empresa}</p> : null}
          <label className="rec-modal-checkbox-row">
            <input
              type="checkbox"
              className="rec-modal-checkbox"
              checked={alterarComercial}
              disabled={submitting}
              onChange={(e) => setAlterarComercial(e.target.checked)}
            />
            <span>Alterar comercial de destino</span>
          </label>
          {alterarComercial ? (
            <div className="rec-modal-reverter-select">
              <p className="rec-modal-text rec-modal-text--transfer">Novo comercial:</p>
              <label className="rec-lead-field rec-lead-field--no-label">
                <select
                  className="rec-select"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  required
                  disabled={submitting}
                  aria-label="Comercial de destino"
                >
                  <option value="">Selecionar utilizador…</option>
                  {users.map((u) => (
                    <option key={u.id} value={String(u.id)}>
                      {u.name}
                      {u.username ? ` (${u.username})` : ''}
                    </option>
                  ))}
                </select>
              </label>
            </div>
          ) : null}
          <div className="rec-modal-actions">
            <button
              type="button"
              className="rec-btn rec-btn-ghost"
              disabled={submitting}
              onClick={onClose}
            >
              Cancelar
            </button>
            <button type="submit" className="rec-btn rec-btn-primary" disabled={submitting}>
              {submitting ? 'A reverter…' : 'Confirmar Reverter'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CccReverterModal;
